import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { OptionContentText } from "../OptionContentText";
import { OptionContentIcon } from "../OptionContentIcon";
import { OptionContentImg } from "../OptionContentImg";
var cn = classNames.bind(style);
export var OptionContent = /*#__PURE__*/memo(function (_ref) {
  var iconSrc = _ref.iconSrc,
    label = _ref.label,
    active = _ref.active,
    theme = _ref.theme,
    toggleConfig = _ref.toggleConfig,
    icon = _ref.icon,
    cardNumber = _ref.cardNumber,
    additionalInfo = _ref.additionalInfo,
    color = _ref.color,
    disabled = _ref.disabled,
    activeOptions = _ref.activeOptions,
    isToggle = _ref.isToggle;
  var isTextSeen = label || cardNumber || additionalInfo || activeOptions;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('option-content'),
    "data-t-id": "components-OptionContent"
  }, iconSrc && /*#__PURE__*/React.createElement(OptionContentImg, {
    iconSrc: iconSrc
  }), isTextSeen && /*#__PURE__*/React.createElement(OptionContentText, {
    activeOptions: activeOptions,
    additionalInfo: additionalInfo,
    cardNumber: cardNumber,
    color: color,
    isToggle: isToggle,
    label: label,
    theme: theme
  }), (active || toggleConfig) && /*#__PURE__*/React.createElement(OptionContentIcon, {
    active: active,
    disabled: disabled,
    icon: icon,
    toggleConfig: toggleConfig
  }));
});